import { useAccessToken } from './useAccessToken';
import { useLogger } from '../context/useLogger';
import { useMemo } from 'react';
import { ODataDsnsService } from '../services/ODataDsnsService';
import { DsnBilansResponse } from '../types/bilan.types';
import { useQuery } from '@tanstack/react-query';

export function useQueryBilans(
  instanceId: string | undefined,
  currentPage: number,
  pageSize: number,
) {
  const getAccessToken = useAccessToken();
  const logger = useLogger();

  const odataService = useMemo(
    () => new ODataDsnsService(getAccessToken, logger),
    [getAccessToken, logger],
  );

  const fetchDsnBilans = () => {
    if (!instanceId) {
      throw new Error('Instance ID is required');
    }
    logger.info('useQueryBilans [fetchDsnBilans] instanceId:', instanceId);
    logger.info('useQueryBilans [fetchDsnBilans] currentPage:', currentPage);
    logger.info('useQueryBilans [fetchDsnBilans] pageSize:', pageSize);

    const data: Promise<DsnBilansResponse> = odataService.fetchDsnBilanList(
      instanceId,
      pageSize,
      currentPage,
    );

    return data;
  };

  logger.info('useQueryBilans instanceId:', instanceId);
  logger.info('useQueryBilans currentPage:', currentPage);
  logger.info('useQueryBilans pageSize:', pageSize);

  const queryKey = ['query-get', 'Bilans', instanceId, currentPage, pageSize];
  const queryResult = useQuery({
    queryKey,
    queryFn: fetchDsnBilans,
    enabled: !!instanceId,
    throwOnError: (_error, query) => query.state.data === undefined,
  });

  return queryResult;
}
